import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { DefaultContext } from '@contexts/pageContext'

import type {
  PageContextPayload,
} from '@sections/Admin/packs/QualityControl/screens/TaskListTemplate/screens/Edit/screens/Details'

import type { TaskListTemplateModel } from '@models/types'

import useTrackingLink from '@hooks/useTrackingLink'
import useTrackingLinks from '@hooks/useTrackingLinks'

import TrackingLink from './TrackingLink'

interface LinksProps {
  taskListTemplate: TaskListTemplateModel,
}

const Links = (props: LinksProps) => {
  const { taskListTemplate } = props

  // @ts-expect-error TS2345
  const pageContext = useContext<DefaultContext<PageContextPayload>>(PageContext)
  const {
    callbacks: {
      deleteTrackingLink,
    },
  } = pageContext

  const taskTrackingLinksPayload = useTrackingLinks({
    filters: {
      recipient_type: 'TaskListTemplate',
      recipient_id: taskListTemplate.id,
    },
    performHttpRequests: !!taskListTemplate.id,
  })

  const { filteredTrackingLinks, hasFilteredTrackingLinks, loading } = taskTrackingLinksPayload

  // Task List Tracking Links
  const taskListTrackingLinkPayload = useTrackingLink({
    owner_id: taskListTemplate.owner_id,
    owner_type: taskListTemplate.owner_type,
    subject_id: taskListTemplate.id,
    subject_type: 'TaskListTemplate',
    recipient_id: taskListTemplate.id,
    recipient_type: 'TaskListTemplate',
  })

  const {
    callbacks: { createOrEditTrackingLink },
  } = taskListTrackingLinkPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      title="Links"
    >
      <Box flexDirection="column">
        {filteredTrackingLinks.map(trackingLink => (
          // @ts-expect-error TS2322
          <TrackingLink callbacks={{ deleteTrackingLink }} key={trackingLink.id} trackingLink={trackingLink} />
        ))}
      </Box>

      <DashboardModule.Footer boxProps={{ borderTop: loading || !hasFilteredTrackingLinks ? 'none' : '1px solid' }}>
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditTrackingLink()}
          marginLeft="auto"
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Link
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

export default Links
